import { useCallback } from 'react';
import { faClone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentNode } from 'assets/js/pages/engage/workflows/hooks/useCurrentNode';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { NodeWithData } from 'assets/js/pages/engage/workflows/utils/types';
import * as DropdownMenu from 'components/dropdown-menu';
import { v4 as uuid } from 'uuid';

const DuplicateNodeMenuItem = () => {
    const currentNode = useCurrentNode();
    const { nodes, edges, setNodes, setShouldLayout, takeSnapshot } = useReactFlowStore(
        ({ nodes, edges, setNodes, setShouldLayout, takeSnapshot }) => ({
            nodes,
            edges,
            setNodes,
            setShouldLayout,
            takeSnapshot,
        }),
    );

    const handleDuplicate = useCallback(() => {
        if (!currentNode?.data) return;

        const newNodeUuid = uuid();
        const newNode = {
            ...currentNode,
            id: newNodeUuid,
            selected: true,
            data: {
                ...currentNode.data,
                stepId: undefined,
                parentId: currentNode.id,
            },
        };

        const bottomEdge = edges.find(edge => edge.source === currentNode.id);
        const newNodes: NodeWithData[] = [
            ...nodes.map(node => {
                if (node.data && node.id === bottomEdge?.target) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            parentId: newNodeUuid,
                        },
                    };
                }

                return node;
            }),
            newNode,
        ];

        takeSnapshot();
        setNodes(newNodes);
        setShouldLayout(true);
    }, [currentNode, nodes, edges, setNodes, setShouldLayout, takeSnapshot]);

    return (
        <DropdownMenu.Item
            onSelect={handleDuplicate}
            onClick={e => e.stopPropagation()}
            className="flex items-center gap-2"
        >
            <FontAwesomeIcon icon={faClone} />
            Duplicate
        </DropdownMenu.Item>
    );
};

export { DuplicateNodeMenuItem };
